import Styles from './EditFavoriteModal.scss';

import Template from './EditFavoriteModal.hbs';
import Chooser from 'views/components/chooser/Chooser'

export default class EditLayoutModal extends BaseView {

    initialize() {
        this.setElement(Template({ Styles }))

        const list = Backbone.Collection.groups.map((groupModel) => {
            return {
                id: groupModel.id,
                label: groupModel.get('name'),
                isChecked: groupModel.get('is_favorite')
            }
        });

        this.chooser = this.addChildView(
            new Chooser({
                list,
                isMultiSelect: true
            }),
            '.js-chooser'
        )
    }

    saveFavorites() {
        const groupIds = _.pluck(this.chooser.getSelection(), 'id')

        Backbone.Collection.groups.each((groupModel) => {
            groupModel.set('is_favorite', groupIds.includes(groupModel.id));
        })

        Backbone.Collection.groups.sort()
        Backbone.View.Components.modal.close()

        $.post('/groups/mark_favorite.json', { groupIds }, () => {
            Backbone.history.loadUrl()
        });
    }

}